// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2ywiV","info":"PatientInfo_info__1PvtA"};